import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';

const Wrapper = styled.div`
  height: ${({ size }) => `${rem(size)}`};
  width: ${({ size }) => `${rem(size)}`};
`;

const Inner = styled.div`
  height: 100%;
  width: 100%;
  animation: rotate 1s infinite linear;
  border: ${({ theme, size, color }) =>
    `${rem(size / 6.5)} solid ${color !== null ? color : theme.color.primary}`};
  border-right-color: transparent;
  border-radius: 50%;

  @keyframes rotate {
    0% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;

const Text = styled.div`
  text-align: center;
  margin-top: ${rem(20)}; 
  font-size: ${rem(20)};
`;

const Div = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const Loader = props => {
  const { size, className, color, text } = props;
  const sizeMapping = {
    m: 16,
    l: 24,
    xl: 40,
    xxl: 110,
  };
  const sizeName = size in sizeMapping ? sizeMapping[size] : 16;
  return (
    <Div>
      <Wrapper className={className} size={sizeName}>
        <Inner size={sizeName} color={color} />
      </Wrapper>
      {text && <Text>{text}</Text>}
    </Div>
  );
};

Loader.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  text: PropTypes.string,
};

Loader.defaultProps = {
  color: null,
  className: null,
  size: 'm',
  text: null,
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.js